import {createSvgIcon} from '../../../icons/utils'

export default createSvgIcon(
  <svg height="24" width="24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="m11.981737,24.043034c6.626963,0 11.999962,-5.372999 11.999962,-11.999988s-5.372999,-12.000008 -11.999962,-12.000008s-12.000011,5.373002 -12.000011,12.000008s5.372998,11.999988 12.000011,11.999988z"
      fill="#fff"
    />
    <path d="m11.981737,21.043034a9,9 0 1 0 0,-18a9,9 0 0 0 0,18z" fill="#F43" />
    <path
      d="m13.308725,8.083046l-0.910994,0c-1.560995,0 -2.341996,0.781001 -2.341996,1.951987c0,1.300998 0.52,1.952016 1.691003,2.733006l0.910994,0.649986l-2.601996,4.034009l-2.082001,0l2.472002,-3.643003c-1.430999,-1.040992 -2.211997,-1.951986 -2.211997,-3.643989c0,-2.081996 1.431001,-3.513 4.163993,-3.513l2.732973,0l0,10.799992l-1.82198,0l0,-9.368988z"
      fill="#fff"
    />
  </svg>,
  'MapGeolocationRu',
)
